import React, { useState } from 'react';
import './Contact.css';
import { contactData } from './data';
import { SupportSection } from '../shared';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    department: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Create email content
      const emailSubject = `Contact Form Submission: ${formData.subject || 'General Inquiry'}`;
      const emailBody = `
Dear Dhyota Global Team,

You have received a new contact form submission with the following details:

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Department: ${formData.department}
Subject: ${formData.subject}

Message:
${formData.message}

---
This message was sent from the Dhyota Global website contact form.
      `.trim();

      // Create mailto link
      const mailtoLink = `mailto:askme@dhyota.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
      
      // Open email client
      window.open(mailtoLink, '_blank');
      
      // Show success message
      setIsSubmitting(false);
      setSubmitStatus('success');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        department: '',
        message: ''
      });
      
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
      
    } catch (error) {
      console.error('Error sending email:', error);
      setIsSubmitting(false);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  const toggleFaq = (faqId) => {
    setOpenFaq(openFaq === faqId ? null : faqId);
  };

  return (
    <main className="contact-page">
      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="contact-form-container">
                <h6 className="section-title text-center">Send us a Message</h6>
                <p className="text-center">Fill out the form below and we'll get back to you within 24 hours.</p>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                          className="form-control"
                          placeholder="Enter your full name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          className="form-control"
                          placeholder="Enter your email address"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter your phone number"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="department">Department</label>
                        <select
                          id="department"
                          name="department"
                          value={formData.department}
                          onChange={handleInputChange}
                          className="form-control"
                        >
                          <option value="">Select a department</option>
                          {contactData.departments.map(dept => (
                            <option key={dept.id} value={dept.name}>
                              {dept.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      className="form-control"
                      placeholder="What is your inquiry about?"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows="6"
                      className="form-control"
                      placeholder="Tell us how we can help you..."
                    ></textarea>
                  </div>
                  
                  <div className="form-actions">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100 text-center"
                      disabled={isSubmitting}
                      style={{ background: "linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)),linear-gradient(90deg, #FF6F00 0%, #FFD93B 100%)", color: "#fff", border: "none", borderRadius: "none", textAlign: "center", borderRadius: "10px" }}
                    >
                      {isSubmitting ? (
                        <>
                          {/* <i className="fas fa-spinner fa-spin"></i> */}
                          Sending...
                        </>
                      ) : (
                        <>
                          Send Message
                        </>
                      )}
                    </button>
                  </div>
                  
                  {submitStatus === 'success' && (
                    <div className="alert alert-success mt-3">
                      <i className="fas fa-check-circle"></i>
                      Thank you! Your email client has opened with your message ready to send to askme@dhyota.com. Please send the email to complete your inquiry.
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="alert alert-danger mt-3">
                      <i className="fas fa-exclamation-circle"></i>
                      There was an error opening your email client. Please try again or contact us directly at askme@dhyota.com.
                    </div>
                  )}
                </form>
              </div>
            </div>
            <div className="col-lg-4">
            <div className='testimonial-card'>
                <div className='testimonial-card-body'>
                  <h5 style={{ fontWeight: "900" }}>Contact Information</h5>
                  <div className='testimonial-card-footer d-flex align-items-center mt-3 justify-content-start'>
                    <img src="/assets/img/contact/location.png" alt="Testimonial 1" />
                    <div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
                    <h3 style = {{marginTop: "-15px"}}>G 2, Krishna Sindhu Residency, 8-2-120/86/2/A & 86/3, Road No. 3, Banjara Hills, Hyderabad - 500034, TG, INDIA</h3>
                    </div>
                  </div>
                  <div className='testimonial-card-footer d-flex align-items-center mt-3 justify-content-start mt-2'>
                    <img src="/assets/img/contact/phone.png" alt="Testimonial 1" />
                    <div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
                    <h3 style = {{marginTop: "-15px"}}>+91 964-964-7108</h3>
                    </div>
                  </div>
                  <div className='testimonial-card-footer d-flex align-items-center mt-3 justify-content-start mt-2'>
                    <img src="/assets/img/contact/email.png" alt="Testimonial 1" />
                    <div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
                    <h3 style = {{marginTop: "-15px"}}>askme@dhyota.com</h3>
                    </div>
                  </div>
                </div>
              </div>
            <div className='testimonial-card mt-3'>
                <div className='testimonial-card-body'>
                  <h5 style={{ fontWeight: "900" }}>Support Hours</h5>
                  <div className='support-hours-container'>
                    <div className='support-hours-row'>
                      <span className='support-hours-day'>Monday - Friday</span>
                      <span className='support-hours-time'>10:00 AM - 5:00 PM</span>
                    </div>
                    <div className='support-hours-row'>
                      <span className='support-hours-day'>Sunday</span>
                      <span className='support-hours-time'>Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            <div className='testimonial-card mt-3'>
                <div className='testimonial-card-body'>
                  <h5 style={{ fontWeight: "900" }}><img src="/assets/img/home/testimonials/shield.png" alt="Testimonial 1" /> Trust & Compliance</h5>
                  <p>Your privacy is our priority. All communications are protected under DPDP Act and EHR standards compliance.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section" style={{ background: "#fff" }}>
        <div className="container">
          <h2 className="section-title text-center">General Enquiries</h2>
          <p className="text-center">For general enquiries, please contact us using the form above.</p>
          <div className="map-container">
            <div className="map-placeholder">
              <img src="/assets/img/contact/enquiries-bg.png" alt="Interactive Map" className='img-fluid' />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title text-center">Frequently Asked Questions</h2>
          <p className="faq-subtitle text-center">Find answers to common questions about our services</p>
          
          <div className="faq-container">
            {contactData.faqs.map((faq) => (
              <div key={faq.id} className="faq-item">
                <div 
                  className="faq-question"
                  onClick={() => toggleFaq(faq.id)}
                >
                  <h4>{faq.question}</h4>
                  <i className={`fas fa-chevron-down ${openFaq === faq.id ? 'rotated' : ''}`}></i>
                </div>
                <div className={`faq-answer ${openFaq === faq.id ? 'open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <SupportSection title="Discover Solutions for Every Stage of Men's Health" description="Join thousands of healthcare professionals who trust Dhyota Global for comprehensive wellness solutions." buttonText="Get Started" buttonClass="white" />
    </main>
  );
};

export default Contact;
